import { useContext } from "react";

import {
  ProposalsContext,
  type ProposalsContextValue,
} from "../contexts/proposalsContext";

export const useProposals = (): ProposalsContextValue => {
  const context = useContext(ProposalsContext);
  if (context === undefined) {
    throw new Error("useProposals must be used within a ProposalsProvider");
  }

  return context;
};
